<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    fullscreen
    hide-overlay
  >
    <v-card tile v-if="selectedEmployee" class="pin-screen">
      <v-toolbar flat class="pin-toolbar">
        <div class="pin-toolbar__identity">
          <span class="pin-toolbar__avatar">
            {{ employeeInitials }}
          </span>
          <div>
            <small>Employee</small>
            <v-toolbar-title class="pin-toolbar__name text-capitalize">
              {{ selectedEmployee.name }}
            </v-toolbar-title>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            icon
            large
            class="pin-close"
            :disabled="loadingClockIn"
            @click="close"
            aria-label="Close PIN screen"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-dialog
        v-model="loadingClockIn"
        persistent
        width="380"
        content-class="pin-loading-dialog"
      >
        <v-card class="pin-loading-card" dark>
          <v-card-text class="pin-loading-content">
            <span class="pin-loading-spinner">
              <v-progress-circular
                :size="42"
                :width="4"
                color="#22d3ee"
                indeterminate
              ></v-progress-circular>
            </span>
            <div class="pin-loading-copy">
              <strong>Verifying your PIN</strong>
              <span>Please wait while we securely process your request.</span>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <main class="pin-content">
        <section class="pin-prompt">
          <div
            class="pin-action-badge"
            :class="{
              'pin-action-badge--out': timeClockStatus === 'Clock Out',
            }"
          >
            <v-icon small>
              {{
                timeClockStatus === "Clock Out"
                  ? "mdi-logout"
                  : "mdi-login"
              }}
            </v-icon>
            {{ timeClockStatus }}
          </div>
          <h1>Enter your PIN</h1>
          <p>Use your 4-digit employee PIN to continue.</p>
        </section>

        <keypadInput
          ref="keypadInput"
          :disabled="loadingClockIn"
          @pinValueSubmit="pinValueSubmit"
        />
      </main>

      <Submit
        :setting="integration"
        :employeeImage="image"
        :status="selectedEmployee.status"
        :openSubmitDialog="openSubmitDialog"
        @closeSubmitDialog="close"
        :employee="selectedEmployee"
      />

      <footer class="pin-footer">
        <button
          type="button"
          class="change-pin-button"
          :disabled="loadingClockIn"
          @click="changePin()"
        >
          <v-icon small class="mr-2 change-pin-button__icon"
            >mdi-lock-reset</v-icon
          >
          Change PIN
        </button>

        <!-- <v-btn @click="showPasswordDialog = true">
          <span>Add Fingerprint</span>
          <v-icon>mdi-fingerprint</v-icon>
        </v-btn> -->

        <!-- <AdminPasswordDialog
          :show="showPasswordDialog"
          @update:show="showPasswordDialog = $event"
          @close="showPasswordDialog = false"
          @authenticated="startFingerprintEnrollment"
        /> -->

      </footer>
    </v-card>
  </v-dialog>
</template>

<script>
// import UserImg from "@/assets/images/user.jpeg";
import timeClockService from "@/modules/TimeClock/service.js";
import authService from "@/modules/Authentication/service.js";
import keypadInput from "@/modules/TimeClock/components/keypad-input.vue";
import Submit from "@/modules/TimeClock/components/submit.vue";
import settingService from "@/modules/Settings/service.js";
// import AdminPasswordDialog from "@/modules/TimeClock/components/AdminPasswordDialog.vue";

export default {
  name: "pin-number",
  props: [
    "pinDialog",
    "selectedEmployee",
    "metadata",
    "integration",
    "locationCode",
  ],
  data() {
    return {
      showPasswordDialog: false,
      value: 0,
      loadingClockIn: false,
      deviceCode: null,
      deviceName: null,
      action: null,
      openSubmitDialog: false,
      timeClock: {
        EmployeeId: null,
        pinCode: null,
      },
      pin: "",
      dialog: false,
      timeClockStatus: null,
      image: null,
    };
  },
  components: {
    Submit,
    // AdminPasswordDialog,
    keypadInput,
  },
  watch: {
    pinDialog(val) {
      // // console.log('this.$parent', this.$parent.$refs.webcom)
      this.dialog = val;
      if (
        this.selectedEmployee &&
        this.selectedEmployee.status === "clockedIn"
      ) {
        this.timeClockStatus = "Clock Out";
      } else {
        this.timeClockStatus = "Clock In";
      }
    },
    dialog(val) {
      if (val) {
        const { deviceName, deviceCode } = authService.getStoredDevice();
        this.deviceName = deviceName;
        this.deviceCode = deviceCode;

        // if (this.$refs && this.$refs.webcam) {
        //   // console.log('ref', this.$refs)
        //   this.$refs.webcam.start();
        // }
      }
    },
  },
  computed: {
    employeeInitials() {
      if (!this.selectedEmployee || !this.selectedEmployee.name) return "";
      return this.selectedEmployee.name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((part) => part.charAt(0))
        .join("")
        .toUpperCase();
    },
  },
  methods: {
    // startFingerprintEnrollment() {
    //   if (
    //     typeof window.AndroidApp !== "undefined" &&
    //     window.AndroidApp.startFingerprintEnrollment
    //   ) {
    //     this.$toast.success("Starting fingerprint enrollment...");
    //     window.AndroidApp.startFingerprintEnrollment();
    //   } else {
    //     this.$toast.error("Android app not available");
    //   }
    // },
    resetPin() {
      this.$refs.keypadInput.clearPin();
      this.pin = "";
    },
    async pinValueSubmit(val) {
      this.loadingClockIn = true;
      this.pin = val;
      if (this.metadata && this.metadata.customClockIn.storeTimeClockImage) {
        this.image = await this.getImage();
        if (this.image) this.image.status = this.status;
      }
      // this.submitPin();
      if (this.checkToken()) {
        // // console.log("have token", this.checkToken());
        this.submitWithToken();
      } else {
        // // console.log("no token");
        this.submitWithNoToken();
      }
    },
    async submitWithNoToken() {
      try {
        const loginInfo = {
          id: this.selectedEmployee.id,
          pin: this.pin,
          locationCode: this.locationCode,
          deviceCode: this.deviceCode,
          deviceName: this.deviceName,
        };
        await authService.authenticate(loginInfo);
        // console.log('auth', auth)
        const result = await authService.setLastEmployeeId(
          this.selectedEmployee.id
        );
        // console.log('result in no token', result)
        if (result) {
          await timeClockService.clockIn({
            EmployeeId: this.selectedEmployee.id,
            clockInNote: "Clocked In through Login Page",
            pinCode: this.pin,
          });
          this.loadingClockIn = false;
          this.openSubmitDialog = true;
          if (
            this.metadata &&
            this.metadata.customClockIn.storeTimeClockImage
          ) {
            this.image.location =
              this.selectedEmployee.LocationEmployee.LocationId;
            this.uploadImage(result.data.id, this.image);
          }
        }
      } catch (error) {
        this.resetPin();
        // console.log("error in submitWithNoToken", error);
        this.loadingClockIn = false;
        this.$toast.error(error.data ? error.data.message : "Error", {
          timeout: 2000,
        });
      }
    },
    async submitWithToken() {
      try {
        this.timeClock.EmployeeId = this.selectedEmployee.id;
        this.timeClock.pinCode = this.pin;
        this.timeClock.LocationId =
          this.selectedEmployee.LocationEmployee.LocationId;

        if (this.selectedEmployee.status === "clockedIn") {
          this.timeClock.clockOutTime = this.$moment().toISOString();
          const result = await timeClockService.clockOut(this.timeClock);
          // console.log('result clockOut', result)
          if (result) {
            this.loadingClockIn = false;
            this.openSubmitDialog = true;
            // console.log('clock out result', this.metadata.customClockIn.storeTimeClockImage)
            if (
              this.metadata &&
              this.metadata.customClockIn.storeTimeClockImage
            ) {
              this.image.location =
                this.selectedEmployee.LocationEmployee.LocationId;
              this.uploadImage(result.data.id, {
                status: this.selectedEmployee.status,
                image: this.image,
              });
            }
          }
        } else {
          this.timeClock.clockInTime = this.$moment().toISOString();
          // console.log('this.timeClock', this.timeClock)
          const result = await timeClockService.clockIn(this.timeClock);
          // console.log('result clockIn', result)
          if (result) {
            this.loadingClockIn = false;
            this.openSubmitDialog = true;
            if (
              this.metadata &&
              this.metadata.customClockIn.storeTimeClockImage
            ) {
              this.image.location =
                this.selectedEmployee.LocationEmployee.LocationId;
              this.uploadImage(result.data.id, {
                status: this.selectedEmployee.status,
                image: this.image,
              });
            }
          }
        }
        // this.closeSubmit()
      } catch (error) {
        // console.log("error in submitWithToken", error);
        this.resetPin();
        this.loadingClockIn = false;
        this.$toast.error(error.data ? error.data.message : "Error", {
          timeout: 2000,
        });
        localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);
      }

      
    },
    async submitPin() {
      // console.log('clockInOutEmployee submitWithToken', this.selectedEmployee)

      try {
        this.timeClock.EmployeeId = this.selectedEmployee.id;
        this.timeClock.pinCode = this.pin;
        this.timeClock.LocationId =
          this.selectedEmployee.LocationEmployee.LocationId;

        if (this.selectedEmployee.status === "clockedIn") {
          this.timeClock.clockOutTime = this.$moment().toISOString();
          const result = await timeClockService.clockOut(this.timeClock);
          // console.log('result clockOut', result)
          if (result) {
            this.loadingClockIn = false;
            this.openSubmitDialog = true;
            // console.log('clock out result', this.metadata.customClockIn.storeTimeClockImage)
            if (
              this.metadata &&
              this.metadata.customClockIn.storeTimeClockImage
            ) {
              this.image.location =
                this.selectedEmployee.LocationEmployee.LocationId;
              this.uploadImage(result.data.id, {
                status: this.selectedEmployee.status,
                image: this.image,
              });
            }
          }
        } else {
          this.timeClock.clockInTime = this.$moment().toISOString();
          // console.log('this.timeClock', this.timeClock)
          const result = await timeClockService.clockIn(this.timeClock);
          // console.log('result clockIn', result)
          if (result) {
            this.loadingClockIn = false;
            this.openSubmitDialog = true;
            if (
              this.metadata &&
              this.metadata.customClockIn.storeTimeClockImage
            ) {
              this.image.location =
                this.selectedEmployee.LocationEmployee.LocationId;
              this.uploadImage(result.data.id, {
                status: this.selectedEmployee.status,
                image: this.image,
              });
            }
          }
        }
        // this.closeSubmit()
      } catch (error) {
        this.resetPin();
        this.loadingClockIn = false;
        this.$swal(
          this.timeClockStatus,
          error.data ? error.data.message : "Error",
          "error"
        );
        // this.$toast.error(error.data ? error.data.message : "Error", {
        //   timeout: 2000,
        // });
        // localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);
      }
    },
    changePin() {
      this.$parent.changePin();
      this.close();
    },
    async getImage() {
      // // console.log('getting image', this.$parent)
      if (this.$parent) {
        return await this.$parent.getImage();
        // return obj
        // // console.log("base64base64base64base64", base64);
        // if (base64) {
        //   const obj = {
        //     dataUrl: base64,
        //     info: {
        //       name: `${this.selectedEmployee.name
        //         .split(" ")
        //         .join("")}-${new Date().getTime()}.jpg`,
        //     },
        //   };
        //   return obj;
        // }
      }
    },
    async uploadImage(id, obj) {
      await settingService
        .uploadMedia(obj.image, { id: obj.image.location })
        .then((response) => {
          // return response;
          // console.log('response', obj, response)
          let image = {};
          if (obj.status === "clockedIn") {
            image.clockOutUrl = response.data.url;
          } else {
            image.clockInUrl = response.data.url;
          }
          // console.log('uploading image', id, image)
          timeClockService.update(id, image);
        })
        .catch(() => {
          this.$toast.error("Unable to upload clock image.");
        });
    },
    checkToken() {
      if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`))
        return true;
    },

    close() {
      this.timeClock = {
        EmployeeId: null,
        pinCode: null,
      };
      this.openSubmitDialog = false;
      this.resetPin();
      this.$emit("close");
    },
    closeSubmit() {
      this.pin = "";
      this.timeClock = {
        EmployeeId: null,
        pinCode: null,
      };
      this.timeClockStatus = null;
      this.resetPin();
      this.$emit("closeSubmit");
    },
  },
};
</script>

<style scoped>
.pin-screen {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background:
    linear-gradient(rgba(96, 165, 250, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(96, 165, 250, 0.025) 1px, transparent 1px),
    radial-gradient(circle at 50% 15%, rgba(37, 99, 235, 0.2), transparent 28rem),
    #07111f;
  background-size: 64px 64px, 64px 64px, auto, auto;
}

.pin-toolbar {
  z-index: 2;
  flex: 0 0 76px;
  padding: 0 clamp(14px, 3vw, 32px);
  border-bottom: 1px solid rgba(148, 163, 184, 0.14) !important;
  background: rgba(7, 17, 31, 0.94) !important;
}

.pin-toolbar__identity {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pin-toolbar__avatar {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  border-radius: 14px;
  border: 1px solid rgba(96, 165, 250, 0.2);
  background: rgba(37, 99, 235, 0.16);
  color: #93c5fd;
  font-size: 14px;
  font-weight: 800;
}

.pin-toolbar__identity small {
  display: block;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.1em;
  line-height: 1.2;
  text-transform: uppercase;
}

.pin-toolbar__name {
  color: #f8fafc;
  font-size: 17px;
  font-weight: 700;
}

.pin-close {
  border: 1px solid rgba(148, 163, 184, 0.16);
  background: rgba(255, 255, 255, 0.05);
  color: #cbd5e1 !important;
}

.pin-content {
  display: flex;
  width: 100%;
  max-width: 620px;
  margin: 0 auto;
  padding: clamp(22px, 4vh, 42px) 24px 24px;
  align-items: center;
  flex: 1 1 auto;
  flex-direction: column;
}

.pin-prompt {
  text-align: center;
}

.pin-action-badge {
  display: inline-flex;
  padding: 7px 12px;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(52, 211, 153, 0.3);
  border-radius: 999px;
  background: rgba(16, 185, 129, 0.1);
  color: #6ee7b7;
  font-size: 12px;
  font-weight: 800;
}

.pin-action-badge--out {
  border-color: rgba(251, 113, 133, 0.3);
  background: rgba(244, 63, 94, 0.1);
  color: #fda4af;
}

.pin-action-badge .v-icon {
  color: inherit;
}

.pin-prompt h1 {
  margin: 14px 0 4px;
  color: #f8fafc;
  font-size: clamp(30px, 5vw, 42px);
  font-weight: 750;
  letter-spacing: -1.2px;
  line-height: 1.1;
}

.pin-prompt p {
  margin: 0;
  color: #94a3b8;
  font-size: 14px;
}

.pin-footer {
  display: flex;
  min-height: 68px;
  padding: 10px 20px;
  align-items: center;
  justify-content: center;
  border-top: 1px solid rgba(148, 163, 184, 0.14);
  background: rgba(7, 17, 31, 0.96);
}

.pin-loading-card {
  overflow: hidden;
  border: 1px solid rgba(34, 211, 238, 0.22) !important;
  border-radius: 20px !important;
  background: linear-gradient(
      135deg,
      rgba(37, 99, 235, 0.12),
      transparent 55%
    ),
    #0d1b2d !important;
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.48) !important;
}

.pin-loading-content {
  display: flex;
  padding: 24px !important;
  align-items: center;
  gap: 17px;
}

.pin-loading-spinner {
  display: grid;
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
  place-items: center;
  border: 1px solid rgba(34, 211, 238, 0.16);
  border-radius: 18px;
  background: rgba(34, 211, 238, 0.07);
}

.pin-loading-copy strong,
.pin-loading-copy span {
  display: block;
}

.pin-loading-copy strong {
  color: #f8fafc;
  font-size: 17px;
  font-weight: 750;
}

.pin-loading-copy span {
  margin-top: 5px;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.45;
}

.change-pin-button {
  display: inline-flex;
  min-height: 44px;
  padding: 0 18px;
  align-items: center;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  background: rgba(255, 255, 255, 0.05);
  color: #cbd5e1;
  font-weight: 700;
  touch-action: manipulation;
}

.change-pin-button .change-pin-button__icon {
  color: #67e8f9 !important;
}

.change-pin-button:active {
  background: rgba(37, 99, 235, 0.18);
  transform: scale(0.98);
}

.change-pin-button:disabled {
  opacity: 0.45;
}

@media (max-width: 600px) {
  .pin-toolbar {
    flex-basis: 68px;
  }

  .pin-toolbar__avatar {
    width: 40px;
    height: 40px;
  }

  .pin-content {
    padding-right: 16px;
    padding-left: 16px;
  }
}

@media (max-height: 720px) {
  .pin-content {
    padding-top: 14px;
  }

  .pin-prompt h1 {
    margin-top: 8px;
    font-size: 30px;
  }

  .pin-prompt p {
    display: none;
  }
}
</style>
